export function filterSuirElementProps(props) {
  const {
    as, // eslint-disable-line
    instantValidation, // eslint-disable-line
    error, // eslint-disable-line
    defaultChecked, // eslint-disable-line
    defaultSelected, // eslint-disable-line
    rootClassName, // eslint-disable-line
    rootStyle, // eslint-disable-line
    defaultValue, // eslint-disable-line
    rootElement, // eslint-disable-line
    errorLabel, // eslint-disable-line
    formRadioGroup, // eslint-disable-line
    getValue, // eslint-disable-line
    isPristine, // eslint-disable-line
    isValid, // eslint-disable-line
    errorMessage, // eslint-disable-line
    setValidations, // eslint-disable-line
    setValue, // eslint-disable-line
    resetValue, // eslint-disable-line
    hasValue, // eslint-disable-line
    isFormDisabled, // eslint-disable-line
    isFormSubmitted, // eslint-disable-line
    isRequired, // eslint-disable-line
    showRequired, // eslint-disable-line
    showError, // eslint-disable-line
    isValidValue, // eslint-disable-line
    validations, // eslint-disable-line
    validationError, // eslint-disable-line
    validationErrors, // eslint-disable-line
    width, // eslint-disable-line
    passRequiredToField, // eslint-disable-line
    inputAs, // eslint-disable-line
    innerRef, //eslint-disable-line
    ...suirProps
  } = props;

  return suirProps;
}
